import API_ENDPOINTS from '../../../api/endpoints/apiEndpoints';
import apiClient from '../../apiClient'; // API 클라이언트
import { BaseResponse } from '../UtilsInterface';
import {
  NoticesApiResponse,
  NoticesBody,
  NoticesData,
} from '../NoticeInterfaces';

// 공지사항 서비스 정의
const AdminNoticeService = {
  // 공지사항 목록 조회
  getAdminNoticesList: async (
    page: number,
    size: number,
    keyword?: string
  ): Promise<NoticesApiResponse> => {
    try {
      const response = await apiClient.get(
        API_ENDPOINTS.get_admin_notices_list(page, size, keyword)
      );
      return response.data;
    } catch (error) {
      console.error('공지사항 목록 조회 실패:', error);
      throw error;
    }
  },

  // 공지사항 상세 조회
  getAdminNoticeDetail: async (
    noticeId: string
  ): Promise<BaseResponse<NoticesData>> => {
    try {
      const response = await apiClient.get(
        API_ENDPOINTS.get_admin_notice_detail(noticeId)
      );
      return response.data;
    } catch (error) {
      console.error('공지사항 상세 조회 실패:', error);
      throw error;
    }
  },

  // 공지사항 등록
  createAdminNotice: async (
    data: NoticesBody
  ): Promise<BaseResponse<string>> => {
    try {
      const response = await apiClient.post(
        API_ENDPOINTS.create_admin_notice(),
        data
      );
      return response.data;
    } catch (error) {
      console.error('공지사항 등록 실패:', error);
      throw error;
    }
  },

  // 공지사항 수정
  updateAdminNotice: async (
    noticeId: string,
    data: NoticesBody
  ): Promise<BaseResponse<string>> => {
    try {
      const response = await apiClient.put(
        API_ENDPOINTS.update_admin_notice(noticeId),
        data
      );
      return response.data;
    } catch (error) {
      console.error('공지사항 수정 실패:', error);
      throw error;
    }
  },

  // 공지사항 삭제
  deleteAdminNotice: async (noticeId: string): Promise<BaseResponse<void>> => {
    try {
      const response = await apiClient.delete(
        API_ENDPOINTS.delete_admin_notice(noticeId)
      );
      return response.data;
    } catch (error) {
      console.error('공지사항 삭제 실패:', error);
      throw error;
    }
  },
};

export default AdminNoticeService;
